/**
 * コアサービスページ翻訳 - 日本語
 * Core Service page translations - Japanese
 */

export default {
  hero: {
    title: 'コアサービス',
    subtitle: '企業のデジタル変革ライフサイクル全体を対象に、戦略立案から日常運用までエンドツーエンドで支援します',
    imageAlt: 'コアサービス背景画像'
  },

  nav: {
    title: 'サービス分類'
  },

  portfolio: {
    eyebrow: 'Service Portfolio',
    introTitle: 'エンドツーエンドのサービス構成',
    introDescription:
      '当社のサービス構成は、企業のデジタル変革ライフサイクル全体を軸に設計されています。戦略立案、導入構築、継続運用まで、地域をまたいで一貫性があり、安定した再現可能な IT サービス能力を提供します。',
    serviceContentTitle: 'サービス内容',
    coreValueTitle: 'コアバリュー',
    sections: [
      {
        id: 'digital-workplace',
        icon: 'fas fa-laptop',
        image: '/images/coreService/it-base.jpg',
        title: 'デジタルワークプレイス',
        subtitle: '効率的で安定した統一的なデジタルオフィス体験',
        description:
          '従業員の日常業務とコラボレーションを対象に、端末、アカウント、コラボレーションツール、リモートワーク、IT 資産ライフサイクルを支援し、生産性と利用体験を向上させます。',
        serviceItems: [
          { icon: 'fas fa-desktop', text: 'ノート PC、デスクトップ、モバイル端末を含む端末・オフィス環境サポート' },
          { icon: 'fas fa-user-cog', text: '入退社時の IT サポート（アカウント、端末、権限）' },
          { icon: 'fas fa-comments', text: 'オフィスソフトウェアとコラボレーションツールのサポート' },
          { icon: 'fas fa-mobile-alt', text: 'リモートワークとモバイルワークのサポート' },
          { icon: 'fas fa-boxes', text: 'IT 資産とデバイスのライフサイクル管理' },
          { icon: 'fas fa-chart-line', text: 'デジタルワーク体験の最適化' }
        ],
        valueItems: [
          {
            icon: 'fas fa-globe-asia',
            title: '地域統一管理',
            points: ['統一 SLA 標準', '集中サービス管理', 'クロスリージョン連携']
          },
          {
            icon: 'fas fa-building',
            title: 'ローカルデリバリー',
            points: ['各国のローカルエンジニアネットワーク', '迅速な応答体制', 'オンサイトとリモートの連携']
          },
          {
            icon: 'fas fa-language',
            title: '多言語サポート',
            points: ['中国語 / 英語 / 日本語 / 韓国語', '異文化コミュニケーション', '複数地域で一貫したサービス体験']
          }
        ]
      },
      {
        id: 'data-center-network',
        icon: 'fas fa-network-wired',
        image: '/images/coreService/base-operatoin.jpg',
        title: 'データセンター・ネットワークインフラサービス',
        subtitle: 'コア業務システムの継続的な安定稼働を支援',
        description:
          '企業ネットワーク、オフィスネットワーク、店舗ネットワーク、データセンターネットワーク、サーバー、ストレージを対象に、信頼性と事業継続性を高めます。',
        serviceItems: [
          { icon: 'fas fa-network-wired', text: '企業ネットワークの構築・保守（LAN / WAN / WiFi）' },
          { icon: 'fas fa-building', text: '店舗ネットワークとオフィスネットワークのサポート' },
          { icon: 'fas fa-tools', text: 'スイッチ、ファイアウォールなどのネットワーク機器設置・設定' },
          { icon: 'fas fa-search', text: 'ネットワーク障害調査と性能最適化' },
          { icon: 'fas fa-server', text: 'データセンターネットワークとサーバールームネットワーク管理' },
          { icon: 'fas fa-database', text: 'サーバーとストレージ機器のサポート' },
          { icon: 'fas fa-clipboard-check', text: 'データセンター運用と定期点検' }
        ],
        valueItems: [
          {
            icon: 'fas fa-shield-alt',
            title: '安定性向上',
            points: ['システムの安定性と可用性を向上', 'コアシステム障害の発生確率を低減', '継続的な運用体制を構築']
          },
          {
            icon: 'fas fa-exclamation-triangle',
            title: '中断リスク低減',
            points: ['ネットワークと機器障害を迅速に特定', '業務停止時間を削減', '緊急オンサイト対応を支援']
          },
          {
            icon: 'fas fa-business-time',
            title: '事業継続性',
            points: ['重要業務の継続稼働を支援', '本社、店舗、データセンターをカバー', '複数地域の運用管理に対応']
          }
        ]
      },
      {
        id: 'retail-store-ops',
        icon: 'fas fa-store',
        image: '/images/industrySolution/industry-ticketAI.jpg',
        title: '店舗 IT 運用ソリューション',
        subtitle: '多国・多店舗向けの標準化運用サポート',
        description:
          '小売チェーンやクロスリージョン事業向けに、スケール可能で標準化された店舗 IT 運用を提供し、各店舗の安定稼働と一貫したサポート体験を実現します。',
        serviceItems: [
          { icon: 'fas fa-headset', text: '店舗の日常 IT 運用と障害対応' },
          { icon: 'fas fa-desktop', text: 'POS や端末を含む店舗機器管理' },
          { icon: 'fas fa-network-wired', text: '店舗ネットワークとシステムサポート' },
          { icon: 'fas fa-plus-circle', text: '新店舗開業時の IT 導入と立ち上げ支援' },
          { icon: 'fas fa-sync-alt', text: '店舗移転、アップグレード、閉店時の IT サポート' }
        ],
        valueItems: [
          {
            icon: 'fas fa-check-circle',
            title: '安定稼働',
            points: ['各店舗の安定運営を確保', '機器とネットワーク障害の影響を低減', '日常運営の重要シーンをカバー']
          },
          {
            icon: 'fas fa-bolt',
            title: '迅速対応',
            points: ['問題へ迅速に対応', '営業への影響を削減', 'リモート診断とオンサイト対応を連携']
          },
          {
            icon: 'fas fa-sitemap',
            title: '統一管理',
            points: ['地域をまたぐ店舗を統一管理', '標準化されたデリバリープロセス', 'サービス品質を集中管理']
          }
        ]
      },
      {
        id: 'cloud-operations',
        icon: 'fas fa-cloud',
        image: '/images/coreService/cloud-it.jpg',
        title: 'クラウド・クラウド運用サービス',
        subtitle: '柔軟で効率的、継続的に最適化されるクラウドアーキテクチャ',
        description:
          'パブリッククラウド、ハイブリッドクラウド、クラウドリソース管理、監視、セキュリティ、コスト最適化を含め、クラウド環境の計画、導入、移行、継続運用を支援します。',
        serviceItems: [
          { icon: 'fas fa-project-diagram', text: 'クラウド環境の導入とアーキテクチャ設計（パブリック / ハイブリッド）' },
          { icon: 'fas fa-cloud-upload-alt', text: 'クラウド移行とシステムのクラウド化' },
          { icon: 'fas fa-cogs', text: 'クラウドリソース管理と運用' },
          { icon: 'fas fa-shield-alt', text: 'クラウド監視とセキュリティ管理' },
          { icon: 'fas fa-chart-pie', text: 'クラウドコスト最適化' }
        ],
        valueItems: [
          {
            icon: 'fas fa-expand-arrows-alt',
            title: '柔軟な拡張',
            points: ['IT の柔軟性と拡張性を向上', 'ピーク対応と迅速な展開を支援', 'マルチクラウドとハイブリッド環境に対応']
          },
          {
            icon: 'fas fa-coins',
            title: 'コスト最適化',
            points: ['リソース利用を最適化', 'クラウドコスト構造を管理', 'リソース効率を継続的に追跡']
          },
          {
            icon: 'fas fa-rocket',
            title: '変化への迅速対応',
            points: ['変化する事業ニーズを支援', 'アプリケーション公開サイクルを短縮', 'クラウド運用の透明性を向上']
          }
        ]
      },
      {
        id: 'digital-transformation',
        icon: 'fas fa-rocket',
        image: '/images/home/home-ai-empowerment.jpg',
        title: 'デジタルトランスフォーメーション支援',
        subtitle: '従来型 IT 運用からデータドリブン管理へ',
        description:
          '会員運営、マーケティング自動化、軽量サービス入口、ナレッジ蓄積、オフィス自動化を通じて、IT 能力を再現可能で拡張可能なデジタル運営体系へ変換します。',
        serviceItems: [
          { icon: 'fas fa-users', text: 'CRM 開発：会員、タグ、ポイント、エンゲージメント、再購入運営を支える C 向け CRM プラットフォームを構築' },
          { icon: 'fas fa-bullhorn', text: 'MA 自動化：Web サイト、CRM、メール、メッセージチャネルをつなぎ、リード育成とマーケティングジャーニーを形成' },
          { icon: 'fas fa-mobile-alt', text: 'ミニプログラム：予約、修理受付、問い合わせ、会員サービスなどのシーン向けにカスタム開発' },
          { icon: 'fas fa-brain', text: 'AI ナレッジベース：FAQ、SOP、チケット経験、製品資料を統合し、意味検索と権限管理を支援' },
          { icon: 'fas fa-robot', text: 'オフィスエージェント：メール、承認、議事録、タスクフロー、ナレッジ Q&A を接続し、社内協業を向上' }
        ],
        valueItems: [
          {
            icon: 'fas fa-database',
            title: 'データドリブン',
            points: ['人に依存した運用からデータドリブンへ移行', '運用データ資産を蓄積', '管理判断の品質を向上']
          },
          {
            icon: 'fas fa-tachometer-alt',
            title: '効率と透明性',
            points: ['運用効率と透明性を向上', '反復的な手作業を削減', 'プロセスとサービス入口を統一']
          },
          {
            icon: 'fas fa-layer-group',
            title: '再現可能な拡張',
            points: ['再現可能な IT 管理体系を構築', '複数地域への展開を支援', '継続的な改善メカニズムを形成']
          }
        ]
      }
    ]
  }
}
